const topics = [
  { name: '动作电影', count: '2.3k', hot: true },
  { name: '喜剧电影', count: '1.8k', hot: true },
  { name: '经典电影', count: '1.5k', hot: false },
  { name: '科幻大片', count: '1.2k', hot: true },
  { name: '悬疑烧脑', count: '980', hot: false },
  { name: '华语佳片', count: '1.6k', hot: true },
  { name: '最新上映', count: '3.1k', hot: true },
  { name: '高分推荐', count: '2.7k', hot: true },
  { name: '纪录片', count: '850', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
            最受关注的电影话题与类型热度一览
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((t) => (
            <a
              key={t.name}
              href="#cards"
              className="group inline-flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all duration-200 cursor-pointer whitespace-nowrap"
              style={{
                borderColor: t.hot
                  ? 'oklch(var(--accent-300) / 0.5)'
                  : 'oklch(var(--secondary-200) / 0.6)',
                backgroundColor: t.hot
                  ? 'oklch(var(--accent-50))'
                  : 'oklch(var(--secondary-50))',
              }}
            >
              {t.hot && (
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-fire-line text-accent-500 text-xs"></i>
                </span>
              )}
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors duration-200">
                {t.name}
              </span>
              <span className={`text-xs px-1.5 py-0.5 rounded-full ${
                t.hot
                  ? 'bg-accent-100 text-accent-700'
                  : 'bg-secondary-100 text-secondary-600'
              }`}>
                {t.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}